import React from 'react'

const ProposeBanner = () => {
  return (
    <>
      <section className="banner-section apropos-section">
      <div class="container position-relative h-100">
    <div className="row">
      <div className="col-lg-12">
        <div className="banner-heading">
          <h1>
          Libérez   <br />
          le potentiel  
          </h1>
        </div>
      </div>
      <div className="col-lg-12">
        <div className="banner-heading banner-heading-bottom">
          <h1>
          de vos   <br />
            <span> immeubles  </span>
          </h1>
        </div>
      </div>
    </div>
  </div>
</section>

    </>
  )
}

export default ProposeBanner
